module.exports = __webpack_public_path__ + "media/images/finest-card-c44d97d86306b0436b885007155e6150.jpeg";